














import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreAccordion',
  data() {
    return {
      isOpen: true
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initialise(this: any) {
      this.isOpen = this.open;
    },
    onAccordionButtonClicked(this: any) {
      this.isOpen = !this.isOpen;
      this.$emit('accordion-opened', this.isOpen);
    }
  },
  watch: {
    open(this: any) {
      this.isOpen = this.open;
    }
  },
  mounted(this: any) {
    this.initialise();
  }
});
